<template>
  <div class="home">
    <div class="message">
      <div class="message-title">好兽药{{chatRoomId}}聊天室</div>
      <div class="message-list">
        <!-- <cube-scroll ref="scroll" :data="speak"> -->
          <div v-for="(item,i) in speak" :key="i">
            <div class="message-left" v-if="item.user.name !== cuName">
              <div class="message-img"><img :src="item.user.portrait"></div>
              <div class="message-info">
                <div class="message-info-name">{{item.user.name}}</div>
                <div class="message-info-text" v-if="item.imageUri"><img :src="'data:image/png;base64,'+item.imageUri"></div>
                <div class="message-info-text" v-else>{{item.content | expression}}</div>
              </div>
            </div>
            <div class="message-right" v-else>
              <div class="message-info">
                <div class="message-info-name">{{item.user.name}}</div>
                <div class="message-info-text" v-if="item.imageUri"><img :src="'data:image/png;base64,'+item.content"></div>
                <div class="message-info-text" v-else>{{item.content | expression}}</div>
              </div>
              <div class="message-img"><img :src="item.user.portrait"></div>
            </div>
          </div>
        <!-- </cube-scroll> -->
      </div>
      <div class="message-send">
        <div class="message-send-input">
          <input type="textarea" resize="none" v-model.lazy="message">
          <!-- <van-field v-model="message"/> -->
        </div>
        <!-- <div class="message-send-img" @click="selectFile">
          <img src="../../assets/chatimg/img.svg">
          <input id="upFile" type="file" ref="upFile" @change="getFile" style="display:none;">
          <span>发图片</span>
        </div> -->
        <div class="message-send-submit">
            <!-- <img src="../../assets/chatimg/send.svg"> -->
          <van-button :loading="isSend" type="info" loading-text="发送中..." text="发送" @click="messagebox"  icon="http://testsaas.sslab.com.cn/plkhsy/static/img/send.2393765d.svg">
            <!-- <span>发送</span> -->
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant';
import { appkey } from '@/api/path.js'
import { ConveTime } from '@/utils/utils.js'
export default {
  name: 'shopdetails',
  inject: ['reload'],
  data() {
    return {
      appkey: appkey,
      speak: [],
      emojiList: [],
      token: localStorage.getItem('chatToken'),
      chatRoomId: '10010',
      message: '',
      id: '',
      cuId:  localStorage.getItem('cuId'),
      cuName:  localStorage.getItem('cuName'),
      portrait:  localStorage.getItem('portrait'),
      scrollY: 0,
      imgList:[],
      msgObj:null,
      show: true,
      percent: 50,
      finished: false,
      container: '',
      msgObj:null,
      isSend: false,
    }
  },
  computed: {
    text() {
      return this.percent.toFixed(0) + '%';
    },
  },
  created(){
    let that = this;
    that.chatRoomId = that.$route.query.roomid
    that.client()
  },
  methods: {
    // 连接融云聊天室
    client() {
      let that = this
      // 表情包
      // RongIMLib.RongIMEmoji.init();
      // that.emojiList = RongIMLib.RongIMEmoji.list;
      // console.log('表情',that.emojiList)

      // 初始化
      RongIMLib.RongIMClient.init(that.appkey);

      // 状态监听器
      RongIMClient.setConnectionStatusListener({
        onChanged: function (status) {
          // status 标识当前连接状态
          switch (status) {
            case RongIMLib.ConnectionStatus.CONNECTED:
              console.log('链接成功');
              break;
            case RongIMLib.ConnectionStatus.CONNECTING:
              console.log('正在链接');
              break;
            case RongIMLib.ConnectionStatus.DISCONNECTED:
              console.log('断开连接');
              break;
            case RongIMLib.ConnectionStatus.KICKED_OFFLINE_BY_OTHER_CLIENT:
               Dialog.alert({
                message: '其他设备登录, 本端被踢',
              }).then(() => {
                that.$router.push({
                  path:'/chatlogin',
                  query:{
                    roomid: that.chatRoomId
                  }
                })
              });
              console.log('其他设备登录, 本端被踢');
              break;
            case RongIMLib.ConnectionStatus.DOMAIN_INCORRECT:
              console.log('域名不正确, 请至开发者后台查看安全域名配置');
              break;
            case RongIMLib.ConnectionStatus.NETWORK_UNAVAILABLE:
              that.reconnection()
              console.log('网络不可用, 此时可调用 reconnect 进行重连');
              break;
            default:
              console.log('链接状态为', status);
              break;
          }
        }
      });

      // 消息监听器
      RongIMClient.setOnReceiveMessageListener({
        // 接收到的消息
        onReceived: function (message) {
          var messageContent = message.content;
          // 判断消息类型
          switch(message.messageType) {
            case RongIMClient.MessageType.TextMessage: // 文字消息
              // that.speak.push(messageContent)
              if (messageContent.content && messageContent.user) {
                that.speak.push(messageContent)
                // that.msgObj = messageContent
                that.scrollBttom()
                // console.log('表情', RongIMLib.RongIMEmoji.symbolToEmoji(messageContent.content));
                console.log('文字内容', messageContent.content);
                console.log('文字内容', messageContent);
                // console.log('集合', that.speak);
              }
              break;
            case RongIMClient.MessageType.ImageMessage: // 图片消息
              that.speak.push(messageContent)
              // console.log('图片缩略图 base64', messageContent); 
              // console.log('原图 url', messageContent.imageUri);
              break;
            case RongIMClient.MessageType.HQVoiceMessage: // 音频消息
              // console.log('音频 type ', messageContent.type); // 编解码类型，默认为 aac 音频
              // console.log('音频 url', messageContent.remoteUrl); // 播放：<audio src={remoteUrl} />
              // console.log('音频 时长', messageContent.duration);
              break;
            case RongIMClient.MessageType.RichContentMessage: // 富文本(图文)消息
              // console.log('文本内容', messageContent.content);
              // console.log('图片 base64', messageContent.imageUri);
              // console.log('原图 url', messageContent.url);
              break;
            case RongIMClient.MessageType.UnknownMessage: // 未知消息
              // console.log('未知消息, 请检查消息自定义格式是否正确', message);
              break;
            default:
              console.log('收到消息', message);
              break;
          }
        }
      });

      // 连接接口
      let token = that.token
      console.log('token=',token)
      if (token == null) {
        that.$createToast({
          txt: '重新登录聊天室',
          type: 'error'
        }).show()
        this.$router.push({
          path:'/chatlogin',
          query:{
            roomid: that.chatRoomId
          }
        })
      } 
      // 开发者后台获取或 Server API 
      RongIMClient.connect(token, {
        onSuccess: function(userId) {
          that.id = userId
          console.log('Connect successfully. ' + userId);
          that.chatRoom()
        },
        onTokenIncorrect: function() {
          console.log('token 无效');
          this.$router.push({
            path:'/chatlogin',
            query:{
              roomid: that.chatRoomId
            }
          })
        },
        onError: function(errorCode){
          var info = '';
          switch (errorCode) {
          case RongIMLib.ErrorCode.TIMEOUT:
            info = '超时';
            break;
          case RongIMLib.ConnectionState.UNACCEPTABLE_PAROTOCOL_VERSION:
            info = '不可接受的协议版本';
            break;
          case RongIMLib.ConnectionState.IDENTIFIER_REJECTED:
            info = 'appkey不正确';
            break;
          case RongIMLib.ConnectionState.SERVER_UNAVAILABLE:
            info = '服务器不可用';
            break;
          }
          console.log('33333=',info);
        }
      });
    },
    // 重新连接融云聊天室
    reconnection() {
      var callback = {
        onSuccess: function(userId) {
          console.log('reconnect success. ' + userId);
        },
        onTokenIncorrect: function() {
          console.log('token 无效');
        },
        onError: function(errorCode) {
          console.log(errorcode);
        }
      };
      var config = {
        auto: true,
        url: 'cdn.ronghub.com/RongIMLib-2.2.6.min.js?d=' + Date.now(),
        rate: [100, 1000, 3000, 6000, 10000]
      };
      RongIMClient.reconnect(callback, config);
    },
    // 加入聊天室
    chatRoom() {
      var chatRoomId = this.chatRoomId;
      var count = 10;
      RongIMClient.getInstance().joinChatRoom(chatRoomId, count, {
        onSuccess: function() {
          console.log('加入聊天室成功'); 
        },
        onError: function(error) {
          console.log('加入聊天室失败', error);
        }
      });
    },
    enterMsg(event){
      if (event.keyCode === 13) {
        this.messagebox() // 发送文本
        event.preventDefault() // 阻止浏览器默认换行操作
        return false
      }
    },
    // 发送消息
    messagebox() {
      let that = this
      if (that.message.length === 0 || that.message === '') {
        that.$createToast({
          txt: '请输入消息文本',
          type: 'error'
        }).show()
        return
      }
      this.isSend = true;
      var textMessageInfo = { 
        content: that.message,
        user: {
          id: that.cuId,
          name: that.cuName,
          portrait: that.portrait
        },
      }
      var msg = new RongIMLib.TextMessage(textMessageInfo);
      var conversationType = RongIMLib.ConversationType.CHATROOM;
      var targetId = that.chatRoomId;  // 目标 ID

      var callBack = {
          onSuccess: function (message) {
            that.isSend = false;
          // message 为发送的消息对象并且包含服务器返回的消息唯一 id 和发送消息时间戳
            console.log('发送文本消息成功', message);
            that.speak.push(message.content)
            that.scrollBttom()
            that.message = ''
          },
          onError: function (errorCode) {
            Dialog.alert({
              message: '请重新加入聊天室',
            }).then(() => {
              that.chatRoom()
              // that.$router.push({
              //   path:'/chatlogin',
              //   query:{
              //     roomid: that.chatRoomId
              //   }
              // })
            });
            
            console.log('发送文本消息失败', errorCode);
            // that.$notify.error({ title: '错误', message: '发送消息失败'});
          }
      };
      var isMentioned = false;  // @ 消息
      var pushContent = 'user 发送了一条消息';  // Push 显示内容
      var pushData = null;  // Push 通知时附加信息, 可不填
      var config = {
          isVoipPush: true // 发送 voip push
      };

      RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, callBack, isMentioned, pushContent, pushData, config);

      // RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
      //   onSuccess: function (message) {
      //     // that.msgObj = message.content
      //     that.speak.push(message.content)
      //     that.message = ''
      //     that.scrollBttom()
      //     // message 为发送的消息对象并且包含服务器返回的消息唯一 id 和发送消息时间戳
      //     console.log('发送文本消息成功', message);
      //   },
      //   onError: function (errorCode) {
      //     that.chatRoom()
      //     console.log('发送文本消息失败', errorCode);
      //   }
      // });
    },
    // 滚动到底部
    scrollBttom(){
      this.$nextTick(() => {
        this.container = this.$el.querySelector(".message-list");
        this.container.scrollTop = this.container.scrollHeight;
      });
    },
    // 选择文件
    selectFile(){
      this.$refs.upFile.click()
    },
    getFile(e){
      let that = this;
      var _file = e.target.files[0];
      var fileType;
      if(_file.type.split('/')[0] == 'image'){
        fileType = RongIMLib.FileType.IMAGE; 
      }
      var config = {
        domain: 'https://upload.qiniup.com',
        fileType: fileType,
        getToken: function(callback) {
          RongIMClient.getInstance().getFileToken(fileType, {
            onSuccess: function(data){
              callback(data.token);
            },
            onError: function(){
              console.error('get file token error', error);
            }
          });
        }
      };
      var uploadCallbacks = {
        onProgress: function(loaded, total) {
          // that.show = true
          that.percent = Math.floor(loaded / total * 100);
          console.log('已上传: ', that.percent);
          // if (that.percent === 100) {
          //   that.show = false
          // }
        },
        onCompleted: function(data) {
          // 上传完成, 调用 getFileUrl 获取文件下载 url
          console.log('上传成功: ', data);
          let fileInfo  = data
          RongIMClient.getInstance().getFileUrl(fileType, data.filename, data.name, {
            onSuccess: function(data) {
              console.log('文件 url 为: ', data.downloadUrl);
              var conversationType = RongIMLib.ConversationType.CHATROOM;
              var targetId = that.chatRoomId;  // 目标 Id
              var msg = null;
              if(_file.type.split('/')[0] == 'image'){
                msg = new RongIMLib.ImageMessage({
                  content: fileInfo.thumbnail,  // 压缩后的 base64 略缩图, 用来快速展示图片, 
                  imageUri: data.downloadUrl,  // 上传到服务器的 url. 用来展示高清图片
                  user: {
                    name: that.cuName,
                    portrait: that.portrait
                  },
                });
              }
              RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
                onSuccess: function (message) {
                  console.log('发送图片、文件消息成功', message);
                  if(message.messageType == 'ImageMessage'){
                    that.imgList.push({
                      url:message.content.fileUrl, type:'1', content:'', user_id:message.senderUserId,
                      time:ConveTime(message.sentTime),
                      user: {
                        name: that.cuName,
                        portrait: that.portrait
                      },
                    })
                  }
                  // that.$set(that.speak,that.speak.length,message)
                  that.speak.push(message.content)
                  that.scrollBttom()
                },
                onError: function (errorCode) {
                  console.log('发送图片、文件消息失败', errorCode);
                }
              });
            },
            onError: function(error) {
              console.log('get file url error', error);
            }
          })
        },
        onError: function(error) {
            console.error('上传失败', error);
        }
      };
      if(_file.type.split('/')[0] == 'image'){
        UploadClient.initImage(config, function(uploadFile) { 
          uploadFile.upload(_file, uploadCallbacks);
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .home {
    padding: 0 0 6vh;
    background: linear-gradient(180deg,#95a0ad, #7b8591 99%);
  }
  .van-cell {
    height: 6vh;
  }
  .van-button__icon {
    line-height: normal;
  }
  .van-button--info {
    color: #fff;
    background-color: #007aff;
    border: 1px solid #007aff;
  }
  .van-button {
    width: 100%;
    height: 6vh;
    line-height: 6vh;
  }
  .message {
    width: 780px;
    margin: 0 auto;
    background: #f4f4f4;
    // height: 2.7rem;
    .message-title {
      height: 8vh;
      line-height: 8vh;
      background: linear-gradient(134deg,#225aeb -1%, #037af5 102%);
      font-size: 26px;
      font-family: PingFangSC, PingFangSC-Bold;
      font-weight: 700;
      text-align: center;
      color: #ffffff;
    }
    .message-list {
      width: 780px;
      height: 80vh;
      // height: 3.8rem;
      overflow: hidden;
      overflow-y: auto;
      background: #f7f7f7;
      .message-left {
        display: flex;
        padding: 0.1rem;
        font-size: 0;
        .message-img {
          flex: 0 0 52px;
          img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            border: 1px solid #ffffff;
            vertical-align: top;
          }
        }
        .message-info {
          flex: 1;
          margin-left: 0.05rem;
          text-align: left;
          font-size: 0;
          .message-info-name {
            // flex: 0 0 0.4rem;
            padding: 0.05rem;
            align-self: top;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
            // vertical-align: top;
            font-size: 14px;
            font-weight: bold;
            color: #333;
          }
          .message-info-text {
            display: inline-block;
            max-width: 60%;
            border-radius: 0.05rem;
            background: #fff;
            padding: 0.05rem;
            line-height: 0.1rem;
            text-align: left;
            align-self: center;
            font-size: 14px;
            font-weight: 600;
            word-break:break-all;
            color: #333;
            img {
              width: 1rem;
            }
          }
        }
      }
      .message-right {
        display: flex;
        padding: 0.1rem;
        font-size: 0;
        .message-img {
          flex: 0 0 52px;
          img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            border: 1px solid #ffffff;
            vertical-align: top;
          }
        }
        .message-info {
          flex: 1;
          margin-left: 0.05rem;
          text-align: right;
          font-size: 0;
          .message-info-name {
            // flex: 0 0 0.4rem;
            padding: 0.05rem;
            align-self: top;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: right;
            // vertical-align: top;
            font-size: 14px;
            font-weight: bold;
            color: #333;
          }
          .message-info-text {
            display: inline-block;
            max-width: 60%;
            border-radius: 0.05rem;
            background: #fff;
            padding: 0.05rem;
            line-height: 0.1rem;
            text-align: left;
            align-self: center;
            font-size: 14px;
            font-weight: 600;
            word-break:break-all;
            color: #333;
            img {
              width: 1rem;
            }
          }
        }
      }
    }
    .message-send {
      display: flex;
      width: 780px;
      .message-send-input {
        flex: 1;
        height: 6vh;
        font-size: 0;
        input {
          width: 96%;
          padding: 0 0.05rem;
          height: 6vh;
          font-size: 16px;
        }
      }
      .message-send-img {
        flex: 0 0 150px;
        height: 6vh;
        line-height: 6vh;
        text-align: center;
        background: #f5a623;
        font-size: 0;
        img {
          width: 24px;
          height: 24px;
          vertical-align: middle;
        }
        span {
          margin-left: 10px;
          font-size: 20px;
          font-family: PingFangSC, PingFangSC-Bold;
          font-weight: 700;
          color: #ffffff;
          vertical-align: middle;
        }
      }
      .message-send-submit {
        flex: 0 0 180px;
        height: 6vh;
        line-height: 6vh;
        text-align: center;
        background: #007aff;
        font-size: 0;
        img {
          width: 24px;
          height: 24px;
          vertical-align: middle;
        }
        span {
          margin-left: 10px;
          font-size: 18px;
          font-family: PingFangSC, PingFangSC-Bold;
          font-weight: 700;
          color: #ffffff;
          vertical-align: middle;
        }
      }
    }
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .van-circle__text {
    color: #fff !important;
  }
</style>